import { useState } from "react";
import { Type } from "lucide-react";

export const TEXT_SWATCHES = ["#FFFFFF", "#111111", "#E5202A", "#1E4FCF", "#F5B700", "#16A34A"];

export const FontSelect = ({ fonts, value, onChange, testId }) => (
  <select className="field" value={value} onChange={(e) => onChange(e.target.value)} style={{ fontFamily: `"${value}"` }} data-testid={testId}>
    {fonts.map((f) => <option key={f} value={f} style={{ fontFamily: `"${f}"` }}>{f}</option>)}
  </select>
);

export const ColorPick = ({ value, onChange, testId }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
    {TEXT_SWATCHES.map((c) => (
      <button key={c} type="button" onClick={() => onChange(c)} className={`h-7 w-7 rounded-full border-2 ${value === c ? "border-[#60A5FA]" : "border-white/20"}`} style={{ background: c }} aria-label={c} />
    ))}
    <input type="color" value={value} onChange={(e) => onChange(e.target.value)} className="h-8 w-10 cursor-pointer rounded bg-transparent" aria-label="Custom color" />
  </div>
);

export const TextTool = ({ fonts, onAdd }) => {
  const [t, setT] = useState({ text: "", font: fonts[0], color: "#FFFFFF" });
  const add = () => {
    if (!t.text.trim()) return;
    onAdd({ ...t, text: t.text.trim().slice(0, 100) });
    setT({ ...t, text: "" });
  };
  return (
    <div className="space-y-3 rounded-xl border border-white/10 bg-black/40 p-4" data-testid="design-text-tool">
      <input className="field" maxLength={100} placeholder="Name, number or slogan" value={t.text} onChange={(e) => setT({ ...t, text: e.target.value })}
        onKeyDown={(e) => e.key === "Enter" && add()} data-testid="design-text-input" />
      <FontSelect fonts={fonts} value={t.font} onChange={(font) => setT({ ...t, font })} testId="design-text-font-select" />
      <ColorPick value={t.color} onChange={(color) => setT({ ...t, color })} testId="design-text-color" />
      <button type="button" onClick={add} className="btn-ghost w-full !py-2" data-testid="design-add-text-button"><Type className="h-4 w-4" />Add Text</button>
    </div>
  );
};
